export default __webpack_public_path__ + "static/media/avatars.c84c98f8.svg";